import React, { Dispatch, SetStateAction, useState } from "react";
// mui components
import { Box, Pagination } from "@mui/material";
import { DataGrid, GridColDef, useGridApiContext } from "@mui/x-data-grid";
type Props = {
    rows: any;
    cols: GridColDef[];
    itemsPerPage: number;
    totalItems: number;
    currentPage: number;
    setCurrentPage: Dispatch<SetStateAction<number>> | any;
};

const TableGrid = ({
    rows,
    cols,
    itemsPerPage,
    totalItems,
    currentPage,
    setCurrentPage,
}: Props) => {
    // custom pagination for grid
    function CustomPagination() {
        const apiRef = useGridApiContext();
        return (
            <Pagination
                color="primary"
                count={Math.ceil(totalItems / itemsPerPage)}
                page={currentPage}
                defaultPage={1}
                onChange={(event, value) => {
                    apiRef.current.setPage(value);
                    setCurrentPage(value);
                }}
            />
        );
    }

    return (
        <Box className="datagrid" width="100%" sx={{ overflow: "auto" }}>
            <DataGrid
                rows={rows}
                columns={cols}
                getRowId={(row) => row.id}
                pagination
                slots={{
                    pagination: CustomPagination,
                }}
                paginationMode="server"
                paginationModel={{
                    page: currentPage - 1,
                    pageSize: itemsPerPage,
                }}
                autoHeight
                rowCount={totalItems}
            />
        </Box>
    );
};

export default TableGrid;
